var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissing(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.004 2a8 8 0 11-.008 16 8 8 0 01.008-16zm0 1.454a6.542 6.542 0 110 13.084 6.542 6.542 0 010-13.084zm1.454 10.039c0 .872-.655 1.592-1.454 1.592-.8 0-1.454-.712-1.454-1.592 0-.872.654-1.585 1.454-1.585.777 0 1.424.676 1.454 1.585zm-.851-2.225H9.4c-.232 0-.421-.203-.436-.45l-.247-5.409c-.015-.276.189-.508.436-.508h1.701c.247 0 .45.232.436.508l-.247 5.409c-.014.247-.203.45-.436.45z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissing);
export default ForwardRef;